import React from 'react';

import { BrowserRouter as Router, Route, Switch, type RouteComponentProps } from 'react-router-dom';

import PageDetail from './page_detail';
import type { ReturnDocument } from './types';

interface Props {
  basePath: string;
  libraryUrl: string;
  companyId: string | null;
  returnDocument: ReturnDocument | null;
}

type RouteParams = { pageType: string; pageId: string };

export default function PageLibraryPage({ basePath, libraryUrl, companyId, returnDocument }: Props) {
  return (
    <Router basename={basePath}>
      <Switch>
        <Route
          path="/:pageType/:pageId"
          render={({ match }: RouteComponentProps<RouteParams>) => (
            <PageDetail
              basePath={basePath}
              companyId={companyId}
              libraryUrl={libraryUrl}
              pageId={match.params.pageId}
              pageType={match.params.pageType}
              returnDocument={returnDocument}
            />
          )}
        />
        <Route
          render={() => (
            <div className="container my-5">
              <p>Page not found.</p>
              <a href={libraryUrl}>Back to the Page Library</a>
            </div>
          )}
        />
      </Switch>
    </Router>
  );
}
